export var getInitialProduct = function getInitialProduct(_ref) {
  var initialProductCode = _ref.initialProductCode,
    products = _ref.products;
  if (initialProductCode) {
    var productIndex = products.findIndex(function (_ref2) {
      var code = _ref2.code;
      return code === initialProductCode;
    });
    var index = productIndex < 0 ? 0 : productIndex;
    return {
      index: index,
      product: products[index]
    };
  }
  return {
    index: 0,
    product: products[0]
  };
};